import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  getUserInfoAction,
  setUserDataAction,
  updateUserInfoAction
} from '@/bus/user/actions'
import { IRootState } from '@/store/reducer'

export const useUser = () => {
  const dispatch = useDispatch()
  const {
    loading,
    loaded,
    errors,
    failed,
    data = {},
    hasToken
  } = useSelector(({ user }: IRootState) => user)

  const getUserInfo = () => dispatch(getUserInfoAction())

  const setUserData = (props: any) => dispatch(setUserDataAction(props))

  const updateUserInfo = (props: any) => dispatch(updateUserInfoAction(props))

  const isAuthorized = useMemo(
    () =>
      hasToken !== null && hasToken === false
        ? false
        : hasToken && loaded && data?.id
        ? true
        : null,
    [loaded, data, hasToken]
  )

  return {
    data,

    loading,
    loaded,
    errors,
    failed,
    getUserInfo,
    isAuthorized,
    setUserData,
    updateUserInfo
  }
}
